import {
  Box,
  Grid,
  GridItem,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import {
  AssignedIcon,
  CompletedIcon,
  IncomingIcon,
  PendingIcon,
} from "../assets/svgs/Icons";
import { useState } from "react";
import IncomingApplication from "./PlannerDashboard/IncomingApplication";
import AssignedApplicationPlanner from "./PlannerDashboard/AssignedApplications";
import CompletedApplications from "./PlannerDashboard/CompletedApplications";
import PendingApplication from "./PlannerDashboard/PendingApplications";
import isAllowed from "../routing/isAllowed";
import { useDispatch, useSelector } from "react-redux";
import { getCount } from "./PlannerDashboard/PlannerSlice";

function Planner() {
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();
  const { counts } = useSelector((state) => state.planner);
  const [isActive, setIsActive] = useState(0);

  const getCounts = async () => {
    try {
      setStatus("pending");
      const result = dispatch(getCount());
      setStatus("success");
    } catch (error) {
      setStatus("failed");
      console.error(error);
    }
  };

  useEffect(() => {
    getCounts();
  }, []);

  const STEP_PAGES = [
    {
      id: 0,
      component: () => <IncomingApplication />,
    },
    {
      id: 1,
      component: () => <AssignedApplicationPlanner />,
    },
    {
      id: 2,
      component: () => <CompletedApplications />,
    },
    {
      id: 3,
      component: () => <PendingApplication />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setPage(tabIndex);
    // Updates localStorage with new active tab index
    localStorage.setItem("activeTab", tabIndex);
  };

  useEffect(() => {
    let storedActiveTab = localStorage.getItem("activeTab") || 0;
    if (storedActiveTab > STEP_PAGES.length - 1) {
      storedActiveTab = 0;
    }
    setPage(parseInt(storedActiveTab));
    setIsActive(parseInt(storedActiveTab));
  }, [page, isActive]);

  return (
    <Box>
      <Box bg="#EDF3F8" marginTop="2rem" borderRadius={"15px"}>
        <Grid
          width={"100%"}
          templateColumns={{
            base: "1fr",
            md: "repeat(2, 1fr)",
            xl: "repeat(4, 1fr)",
          }}
          my={"1rem"}
          gap="1rem"
          height={"100%"}
        >
          <GridItem>
            <Box
              bg={isActive === 0 ? "#fff" : "#D4EEFF"}
              color="#141D43"
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              boxShadow={
                isActive === 0
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              textAlign={"center"}
              onClick={() => {
                handleTabClick(0);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <IncomingIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={{ base: "32px", md: "38px", lg: "44px" }}
                  >
                    {counts?.["INCOMING"]?.PLANNER || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "14px", md: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Incoming Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 1 ? "#fff" : "#52C4FF"}
              color="#141D43"
              width={"100%"}
              height={"178px"}
              boxShadow={
                isActive === 1
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              onClick={() => {
                handleTabClick(1);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <AssignedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={{ base: "32px", md: "38px", lg: "44px" }}
                  >
                    {counts?.["ASSIGNED"]?.PLANNER || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "14px", md: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Assigned Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 2 ? "#fff" : "#FE96A6"}
              color="#141D43"
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 2
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(2);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <CompletedIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={{ base: "32px", md: "38px", lg: "44px" }}
                  >
                    {counts?.["COMPLETED"]?.CERTIFIER || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "14px", md: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Completed Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
          <GridItem>
            <Box
              bg={isActive === 3 ? "#fff" : "#FFD5D3"}
              color="#141D43"
              width={"100%"}
              height={"178px"}
              cursor={"pointer"}
              borderRadius={"15px"}
              textAlign={"center"}
              boxShadow={
                isActive === 3
                  ? " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                  : ""
              }
              onClick={() => {
                handleTabClick(3);
              }}
            >
              <Grid templateColumns="repeat(2,1fr)">
                <GridItem mt={"3rem"}>
                  <PendingIcon width="20" height="20" />
                </GridItem>
                <GridItem mt={"1rem"} mr={"1rem"}>
                  <Text
                    fontWeight={"bold"}
                    fontSize={{ base: "32px", md: "38px", lg: "44px" }}
                  >
                    {counts?.["RE-PLAN"]?.PLANNER || 0}
                  </Text>
                  <Text
                    fontSize={{ base: "14px", md: "18px", lg: "24px" }}
                    fontWeight="500"
                    textAlign={"left"}
                  >
                    Pending Applications
                  </Text>
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
      {STEP_PAGES[page].component()}
    </Box>
  );
}

export default isAllowed(Planner);
